import React from 'react';
import { Button } from 'reactApp/ui/Button/Button';

import styles from '../UploadBigFileDialog.css';
import { EShowTariffType, IBigFileModalContent } from '../UploadBigFileDialog.types';

export const useButtons = ({ subscription, numberOfFiles, files, callbacks }: IBigFileModalContent): JSX.Element => {
    const { showTariffType } = subscription;

    let buttonBuyText = 'Посмотреть тарифы';
    let buttonSkipText = 'Отменить загрузку';

    if (numberOfFiles > 1) {
        buttonSkipText = files ? 'Пропустить файлы' : 'Пропустить файл';
    }

    if (showTariffType === EShowTariffType.TRIAL) {
        buttonBuyText = 'Попробовать бесплатно';
    }

    return (
        <div className={styles.buttonWrapper}>
            <Button
                className={styles.button}
                onClick={callbacks.onRequestPayment}
                data-name="request-payment"
                theme="octavius"
                primary
                middle
            >
                {buttonBuyText}
            </Button>
            <Button className={styles.button} onClick={callbacks.onSkip} theme="octavius" data-name="skip" middle>
                {buttonSkipText}
            </Button>
        </div>
    );
};
